import { Box, Divider, Flex, Heading, Text } from '@podiumhq/design-system';
import { useExperiment } from '@podiumhq/tracking';

import PodiumLogoIcon from 'components/PodiumLogo/PodiumLogoIcon';
import { getBundlePrices } from 'components/PricingPackaging/utils';
import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';
import { BUY_NOW_WITH_DISCOUNT } from 'lib/amplitude/flags.constants';

const SelectedPlanSummary = ({ term = 'month', ...boxProps }) => {
  const [fetchingExperiment, showDiscountPricing] = useExperiment(
    BUY_NOW_WITH_DISCOUNT
  );
  const { discountPrices, selectedPlan = {} } =
    useSelectPlanCheckoutContext() || {};

  const { displayName: planName, monthlyPrice: price } = selectedPlan || {};
  const lineHeight = '150%';
  const boldTextStyles = {
    fontSize: 'lg',
    fontWeight: 'medium',
    lineHeight,
  };

  const lightTextStyles = {
    fontSize: 'md',
    lineHeight,
  };

  const discountPrice = getBundlePrices({
    allPrices: discountPrices,
    bundlePlan: selectedPlan.plan,
  });

  return (
    <Box
      backgroundColor="silver.light"
      borderRadius="12px"
      boxSizing="border-box"
      padding="24px"
      width="100%"
      {...boxProps}
    >
      <Flex>
        <PodiumLogoIcon height="48px" mr="16px" width="48px" />
        <Box>
          <Heading color="black.base" mb="2px" {...boldTextStyles}>
            {planName}
          </Heading>

          <Text fontSize="md" fontWeight="normal" lineHeight="150%">
            ${price} USD / {term} + taxes
          </Text>
        </Box>
      </Flex>

      <Divider mt="24px" mb="20px" />

      {!fetchingExperiment && showDiscountPricing === 'on' && discountPrice && (
        <>
          <Flex justify="space-between">
            <Text {...lightTextStyles}>Subtotal</Text>
            <Text {...lightTextStyles}>${discountPrice.discountPrice}</Text>
          </Flex>
          <Flex justify="space-between" mt="15px">
            <Box display="inline-flex">
              <Text mt="2px" {...lightTextStyles}>
                Welcome Discount
              </Text>
              <Box
                bg="grey.lightest"
                borderRadius="4px"
                padding="2px 7px"
                ml="7px"
              >
                <Text {...lightTextStyles}>
                  {discountPrice.discountPercentage}% off
                </Text>
              </Box>
            </Box>
            <Text {...lightTextStyles}>
              -${(discountPrice.price * discountPrice.discountPercentage) / 100}
            </Text>
          </Flex>
          <Divider mt="24px" mb="20px" />
        </>
      )}

      <Flex justify="space-between">
        <Text {...boldTextStyles}>Total</Text>
        <Text {...boldTextStyles}>${price}</Text>
      </Flex>
      <Flex justify="right">
        <Text {...lightTextStyles}>USD / month + taxes</Text>
      </Flex>
    </Box>
  );
};

export default SelectedPlanSummary;
